<template>
    <div class="form-group">
        <label :class="{'text-danger': error }" for="password">
            {{ label }}
        </label>
        <router-link
            v-show="changePassword"
            :to="{name: 'change-password'}"
            class="text-primary change-password"
        >
            CHANGE
        </router-link>
        <div v-show="!changePassword" class="toggle-show-password" @click="toggleShowPassword">
            <img
                v-show="showPasswordToggle"
                :title="showPassword ? 'Hide password' : 'Show password'"
                :src="require(`@assets/img/eyes_${showPassword ? 'open' : 'close'}.svg`)"
            >
        </div>
        <input
            :id="$attrs.id"
            :autocomplete="$attrs.autocomplete"
            :class="{ 'is-danger': error, 'disable-pointer': disablePointer }"
            :disabled="$attrs.disabled"
            :name="$attrs.name"
            :type="showPassword ? 'text' : 'password'"
            :value="value"
            class="form-control"
            @input="(e) => $emit('input', e.target.value)"
            @change="updateValue"
            @blur="$emit('blur')"
        >
        <span v-show="error" class="text-danger">
            {{ error }}
        </span>
    </div>
</template>

<script>
export default {
    name: "PasswordInput",
    $_veeValidate: {
        name() {
            return this.$attrs.name;
        },
        value() {
            return this.value;
        }
    },
    props: {
        value:{
            type: String,
            default: ""
        },
        changePassword: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default:""
        },
        showPasswordToggle: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            default: "password"
        },
        disablePointer: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showPassword: false
        };
    },
    methods: {
        toggleShowPassword() {
            this.showPassword = !this.showPassword;
        },
        updateValue(e) {
            this.$validator.validate(this.$attrs.name);
            this.$emit("input", e.target.value);
        }
    }
}
</script>

<style lang="scss" scoped>
    .toggle-show-password,
    .change-password {
        position: absolute;
        right: 14px;
        display: flex;
        top: 34px;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
    }

    .toggle-show-password {
        width: 20px;
        height: 20px;
    }

    .disable-pointer {
        cursor: not-allowed;
        pointer-events: none;
    }
</style>
